import React from "react";
import ProfitReport from "../../components/Report/ProfitReport";

const ProfitReportPage: React.FC = () => <ProfitReport />;

export default ProfitReportPage;
